import React from "react";
import { useDispatch, useSelector } from "react-redux";
import FormText from "./form/formText.component";
import ContainerBox from "./common/containerBox.component";
import { stateProps } from "../types";
import { changeGender } from "../actions";
import FormRadioGroupInput from "./form/formRadioGroupInput.component";

const Gender: React.FC = () => {
  const dispatch = useDispatch();

  const items = ["Female", "Male", "Prefer not to say"];

  const gender = useSelector(
    (state: { router: History; doctorInfo: stateProps }) =>
      state.doctorInfo.gender
  );

  const onInputChange: React.ChangeEventHandler<HTMLInputElement> = (event) => {
    const { value } = event.target;
    dispatch(changeGender(value));
  };

  return (
    <React.Fragment>
      <ContainerBox>
        <FormText number={"03"} title={"Gender?"} optional={"(Optional)"} />
        <FormRadioGroupInput
          onInputChange={onInputChange}
          value={gender}
          items={items}
        />
      </ContainerBox>
    </React.Fragment>
  );
};

export default Gender;
